import {
  BusinessTypeStep,
  IndustryStep,
  GoalsStep,
  BudgetStep,
  FeaturesStep,
  TeamSizeStep,
  BusinessStageStep,
  TechnicalExpertiseStep
} from '../steps';

export const stepComponents = {
  businessType: BusinessTypeStep,
  industry: IndustryStep,
  goals: GoalsStep,
  budget: BudgetStep,
  features: FeaturesStep,
  teamSize: TeamSizeStep,
  businessStage: BusinessStageStep,
  technicalExpertise: TechnicalExpertiseStep
} as const;